<div class="layout-container">
	<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
	<div class="spinner" *ngIf="loading">
		<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
	</div>

	<div class="mdc-layout-grid__inner" [ngClass]="{ 'margin-bottom-5em': embedded }">
		<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone p-3">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell--span-12">
					<span class="fs-20px fw-500 d-block mb-1">{{ locale.translations['payment']['n595'] }}</span>
					<span class="fg-light-grey d-block">{{ locale.translations['payment']['n596'] }}</span>
				</div>
			</div>

			<!-- Voucher Code -->
			<div class="custom-expansion-panel my-3" (click)="onPaymentMode('voucherCode')">
				<div class="custom-expansion-panel-header" [ngClass]="{ 'other-expansion': locale.lang !== 'en' }">
					<div class="custom-panel-title">
						<img [src]="'/assets/images/payment/asiacell.png' | s3Image" class="voucher-img" />
						<div class="d-flex flex-column">
							<span class="fs-16px fw-500">{{ locale.translations['payment']['n591'] }}</span>
							<span class="subtitle fs-14px fw-400 fg-light-grey">{{ locale.translations['payment']['n592'] }}</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Transfer Mobile Balanace -->
			<div class="custom-expansion-panel" (click)="onPaymentMode('mobileBalance')">
				<div class="custom-expansion-panel-header" [ngClass]="{ 'other-expansion': locale.lang !== 'en' }">
					<div class="custom-panel-title">
						<img [src]="'/assets/images/payment/credit-transfer.svg' | s3Image" class="voucher-img" />
						<div class="d-flex flex-column">
							<span class="fs-16px fw-500">{{ locale.translations['payment']['n593'] }}</span>
							<span class="subtitle fs-14px fw-400 fg-light-grey">{{ locale.translations['payment']['n594'] }}</span>
						</div>
					</div>
				</div>
			</div>

			<!--credit card from-->
			<div class="custom-expansion-panel my-3" (click)="onStripePayment()">
				<div class="custom-expansion-panel-header" [ngClass]="{ 'other-expansion': locale.lang !== 'en' }">
					<div class="custom-panel-title">
						<img [src]="'/assets/images/payment/credit-card.png' | s3Image" class="voucher-img" />
						<div class="d-flex flex-column">
							<span class="fs-16px fw-500">{{ locale.translations['payment']['n626'] }}</span>
							<span class="subtitle fs-14px fw-400 fg-light-grey">{{ locale.translations['payment']['n627'] }}</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Fast Pay hiddeden -->
			<mat-expansion-panel hidden>
				<mat-expansion-panel-header [ngClass]="{ 'other-expansion': locale.lang !== 'en' }">
					<mat-panel-title class="font-weight-semi-bold">
						{{ locale.translations['payment']['n468'] }}
					</mat-panel-title>
				</mat-expansion-panel-header>
			</mat-expansion-panel>

			<div class="mdc-layout-grid__inner d-flex justify-content-between align-items-center desktop-style">
				<div class="mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-2-phone">
					<h3 class="fw-500 mb-0">{{ locale.translations['payment']['n465'] | uppercase }}</h3>
				</div>
				<div class="mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-2-phone">
					<h3 class="fw-500 mb-0" *ngIf="category === '15' || category === '17' || category === '0'; else other3">
						{{ queryPackage === 'vip' ? locale.translations['payment']['n223'] : locale.translations['payment']['n222'] }}
					</h3>
					<ng-template #other3>
						<h3 class="fw-500 mb-0">
							{{ queryPackage === 'vip' ? locale.translations['payment']['n223'] : locale.translations['payment']['n222'] }}
						</h3>
					</ng-template>
				</div>
			</div>
		</div>
	</div>
</div>
